/** Named spacing constants that map to design tokens in styles/tokens/spacing.css.
 *  Use for ALL spacing properties: gap, margin, padding.
 *  Applies the 4px base rhythm from the design system. */
export type SpacingSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl'

/** Map a named size to its CSS custom property.
 *  For values not covered by named sizes, use var(--space-N) directly. */
export const spacing: Record<SpacingSize, string> = {
  xs: 'var(--space-1)', // 4px  — tight icon gaps
  sm: 'var(--space-2)', // 8px  — small gaps, compact content, button groups
  md: 'var(--space-3)', // 12px — standard card content
  lg: 'var(--space-4)', // 16px — generous form sections
  xl: 'var(--space-6)', // 24px — section gaps, card grids
  '2xl': 'var(--space-8)', // 32px — large section separators
}
